import type { JSX } from 'react';

import { Translate } from '@change/core/react/i18n';

import { Button } from '@change-corgi/design-system/components/actions';

export function Buttons(): JSX.Element {
	return (
		<Button type="submit">
			<Translate value="fe.components.petition_report_abuse.form_submit" />
		</Button>
	);
}
